import React from 'react';
import displayName from 'component-lib/displayName';
import styles from './Spacer/style.scss';

function createSpacer(size) {
    const className = `spacer-${size}`;
    return <span className={styles[className]} />;
}

export function SpacerLarge() {
    return createSpacer('large');
}
SpacerLarge.displayName = displayName('Buttons/SpacerLarge');

export function SpacerMedium() {
    return createSpacer('medium');
}
SpacerMedium.displayName = displayName('Buttons/SpacerMedium');

export function SpacerSmall() {
    return createSpacer('small');
}
SpacerSmall.displayName = displayName('Buttons/SpacerSmall');

export function SpacerXSmall() {
    return createSpacer('x-small');
}
SpacerXSmall.displayName = displayName('Buttons/SpacerXSmall');

export default function Spacer() {
    return <SpacerLarge />;
}
